import { useNavigate } from 'react-router';
import { releaseNotes } from './releaseNotes.js';

export function ReleaseNotesView() {
  const navigate = useNavigate();

  return (
    <div className="p-4 max-w-lg mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-500 hover:text-gray-700"
          aria-label="戻る"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h1 className="text-xl font-bold">リリースノート</h1>
      </div>

      <div className="space-y-6">
        {releaseNotes.map((note) => (
          <div key={note.version} className="border border-gray-100 rounded-lg p-4">
            <div className="flex items-baseline justify-between mb-3">
              <span className="font-bold text-primary text-lg">v{note.version}</span>
              <span className="text-xs text-gray-400">{note.date}</span>
            </div>
            <ul className="space-y-1.5">
              {note.changes.map((change, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />
                  {change}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
